import { workAreaRoutePath } from '@featit/shared/addressing/paths';

/** The Schedules list of one work area (F-0424). Scoped only: a schedule belongs to its work area. */
export function projectSchedulesPath(projectSlug: string): string {
  return workAreaRoutePath(projectSlug, '/schedules');
}

export function newSchedulePath(projectSlug: string): string {
  return workAreaRoutePath(projectSlug, '/schedules/new');
}

/** §8.5: the New form, filled from a kept schedule no machine runs yet, to put it on one. */
export function putOnSchedulePath(projectSlug: string, scheduleSlug: string): string {
  return `${newSchedulePath(projectSlug)}?putOn=${encodeURIComponent(scheduleSlug)}`;
}

/** One schedule's page, by slug (a slug is lower-case words and hyphens, one segment). */
export function projectSchedulePath(projectSlug: string, scheduleSlug: string): string {
  return workAreaRoutePath(projectSlug, `/schedules/${encodeURIComponent(scheduleSlug)}`);
}

export function editSchedulePath(projectSlug: string, scheduleSlug: string): string {
  return `${projectSchedulePath(projectSlug, scheduleSlug)}/edit`;
}

/** One run of a schedule: a panel over the schedule's page, a page of its own on a phone. */
export function scheduleRunPath(projectSlug: string, scheduleSlug: string, runId: string): string {
  return `${projectSchedulePath(projectSlug, scheduleSlug)}/runs/${encodeURIComponent(runId)}`;
}
